import { useEffect } from "react"
import { AlertTriangle, BarChart3, Search, FileText, ShieldCheck, RotateCcw, LucideIcon } from "lucide-react"
import { Helmet } from 'react-helmet-async';
import { useLocation } from "react-router-dom"
import LandingChrome from "src/components/search/LandingChrome"

const SECTIONS: { id?: string; title: string; body: string; Icon: LucideIcon }[] = [
    {
        title: "Disclaimer",
        Icon: AlertTriangle,
        body: "The house valuation estimates provided are for informational purposes only and should not be considered as financial or professional advice.",
    },
    {
        title: "Data Accuracy",
        Icon: BarChart3,
        body: "While we strive to provide accurate valuations based on available market data, property values can vary significantly based on numerous factors including condition, market conditions, and local factors not captured in our analysis.",
    },
    {
        title: "Professional Advice",
        Icon: Search,
        body: "For important financial decisions regarding property, we strongly recommend consulting with qualified real estate professionals, appraisers, or financial advisors who can provide personalized advice based on your specific circumstances.",
    },
    {
        title: "Service Usage",
        Icon: FileText,
        body: "By using HomeIndex, you agree to use our service responsibly and understand that our valuations are estimates only. We reserve the right to modify or discontinue our service at any time.",
    },
    {
        title: "Limitation of Liability",
        Icon: ShieldCheck,
        body: "HomeIndex and its operators shall not be liable for any decisions made based on the information provided through our service. Users assume full responsibility for any actions taken based on our valuation estimates.",
    },
    {
        id: "refunds",
        title: "Analyst Report Refunds",
        Icon: RotateCcw,
        body: "If your analyst report is not delivered within the time we promised, or it does not help you, email info@homeindex.ie within 14 days of receiving it and tell us briefly why. We refund the full amount to the card you paid with, through Stripe, usually within 5 to 10 working days. One refund per home per customer; once refunded, access to the report is removed. Because work on your report starts as soon as you pay, you agree when paying that the statutory 14 day cancellation period for digital services does not apply. This refund promise is offered in addition to that, and does not affect your other statutory rights.",
    },
]

export default function TermsPageNext({ stateHandler, loginHelper }: { stateHandler: any; loginHelper?: any }) {
    const { hash } = useLocation()
    useEffect(() => {
        if (hash) document.getElementById(hash.slice(1))?.scrollIntoView()
    }, [hash])

    return (
        <LandingChrome stateHandler={stateHandler} loginHelper={loginHelper}>
            <Helmet>
                <title>Terms of Use</title>
                <meta name="description" content="Important information about using HomeIndex - valuation estimates, data accuracy, and limitations." />
                <link rel="canonical" href="https://homeindex.ie/terms" />
            </Helmet>

            <main className="landing-doc">
                <div className="landing-doc-inner">
                    <header className="landing-doc-header">
                        <span className="landing-doc-eyebrow">Legal</span>
                        <h1>Terms of Use</h1>
                        <p>Important information about our service.</p>
                    </header>

                    <div className="landing-doc-grid">
                        {SECTIONS.map(({ id, title, body, Icon }) => (
                            <article className="landing-doc-card" key={title} id={id}>
                                <span className="landing-doc-card-icon" aria-hidden>
                                    <Icon size={24} strokeWidth={2} />
                                </span>
                                <div>
                                    <h2>{title}</h2>
                                    <p>{body}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </main>
        </LandingChrome>
    )
}
